import axios from "axios";
import {API_URL} from "../config";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {GET_NOTIFICATION_ERROR} from "../types/types";
import {setUserError} from "../actions/actionsUsersList";
import {SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {hideError, hideErrorMessage} from "../actions/actions";
import {
    GET_TRUNK_STATISTICS,
    GET_TRUNK_STATISTICS_PAGINATION,
    GET_TRUNK_STATISTICS_FILES_HISTORY,
    SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER,
    GET_TRUNK_STATISTICS_FILES_PAGINATION,
} from "../types/typesTrunkStatisticsList";
import {
    showTrunkStatisticsExportLoader,
    showTrunkStatisticsLoader,
} from "../actions/actionsTrunkStatistics";

export function getTrunkStatisticsWithPaginationFilterAndSorting(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showTrunkStatisticsLoader(true));
        axios.post(`${API_URL}Statistic/GetStatisticTrunksByTrunkIdPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((response) => {
                dispatch({type: GET_TRUNK_STATISTICS, payload: response.data.data});
                dispatch({type: GET_TRUNK_STATISTICS_PAGINATION, payload: response.data.data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showTrunkStatisticsLoader(false));
            });
    };
}

export function getActiveTrunksForStatistics(jwtToken: any) {
    return axios.post(
        `${API_URL}Trunks/GetTrunksWithPagination`,
        {
            isActive: true,
            isArchived: false,
            pageNumber: 1,
            pageSize: 1000,
            sort: {
                orderBy: 'Id',
                isDesc: false,
            },
        },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
        },
    );
}

export function getTrunkStatisticExcel(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showTrunkStatisticsExportLoader(true));
        return axios.post(`${API_URL}Statistic/GenerateStatistic?type=5`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                return true;
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(setUserError(true));
                }
                return false;
            })
            .finally(() => {
                dispatch(showTrunkStatisticsExportLoader(false));
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch(setUserError(false));
            });
    };
}

export function getTrunkStatisticsFilesHistory(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER, payload: true});
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        axios.post(`${API_URL}Statistic/GetFilesHistory?type=5`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: GET_TRUNK_STATISTICS_FILES_HISTORY, payload: response.data.data.items});
                dispatch({type: GET_TRUNK_STATISTICS_FILES_PAGINATION, payload: response.data.data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER, payload: false});
                dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
            });
    };
}

export function deleteTrunkStatisticsFileById(id: number | any, dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteFileById?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch(getTrunkStatisticsFilesHistory(dataSort, jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function deleteAllTrunkStatisticsFiles(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteAllFiles`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch({type: GET_TRUNK_STATISTICS_FILES_HISTORY, payload: []});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function getTrunkStatisticExcelByLink(id: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showTrunkStatisticsExportLoader(true));
        axios.get(`${API_URL}Statistic/GetTempUrlFile?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                const fileUrl = response.data.data;
                const fileName = response.data.title || 'export.xlsx';

                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    dispatch(setUserError(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showTrunkStatisticsExportLoader(false));
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}
